import React, { useRef, useEffect } from "react";

const HowItWorks = () => {
  const sectionRef = useRef(null);
  const wrapperRef = useRef(null); // container wrapper
  const descRef = useRef(null); // your .scroll-reveal-main
  const cardsRef = useRef([]); // will hold the 3 card DOM nodes
  const progressRef1 = useRef(null);
  const progressRef2 = useRef(null);
  const progressRef3 = useRef(null);

  // helper to clamp
  const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));

  useEffect(() => {


    const viewportWidth = window.innerWidth;
    // console.log(viewportWidth, " viewportWidth");
    const device_type = viewportWidth < 991 && viewportWidth < 767 ? "mobile" : (viewportWidth < 991 && viewportWidth > 767) ? "ipad" : "desktop";

    console.log("device_type = ", device_type);
    if (device_type == "mobile") {

      window.addEventListener("scroll", mobileVisibility, { passive: true });
      window.addEventListener("resize", mobileVisibility);
      mobileVisibility();

      return () => {
        window.removeEventListener("scroll", mobileVisibility);
        window.removeEventListener("resize", mobileVisibility);
      };

    } else if (device_type == "ipad") {

      window.addEventListener("scroll", ipadVisibility, { passive: true });
      window.addEventListener("resize", ipadVisibility);
      ipadVisibility();

      return () => {
        window.removeEventListener("scroll", ipadVisibility);
        window.removeEventListener("resize", ipadVisibility);
      };

    } else if (device_type == "desktop") {

      // Make sure the section has enough height so the sticky inner area can pin
      // Section height = viewportHeight * (cardsCount + 1)
      // That gives us a scroll distance of viewportHeight * cardsCount inside the pinned area


      // initialize layout and listeners
      setSectionHeight();
      window.addEventListener("resize", setSectionHeight);
      window.addEventListener("scroll", handleScroll, { passive: true });

      // ensure initial styles for cards
      cardsRef.current.forEach((card) => {
        if (card) {
          card.style.transition = "opacity 0.35s ease-out, transform 0.45s ease-out";
          card.style.opacity = 0;
          card.style.transform = "translateY(30px)";
          card.style.willChange = "opacity, transform";
        }
      });

      // run once to set state correctly on mount
      handleScroll();

      return () => {
        window.removeEventListener("resize", setSectionHeight);
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const mobileVisibility = () => {
    const viewportWidth = window.innerWidth;
    const device_type = viewportWidth < 991 && viewportWidth < 767 ? "mobile" : (viewportWidth < 991 && viewportWidth > 767) ? "ipad" : "desktop";
    // const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    // const zoomRatio = window.devicePixelRatio || 1;
    //const isMobile = viewportWidth < 800;
    const direction = "height";

    const sectionTop = descRef.current?.offsetTop || 0;
    const localScrollY = scrollY;

    const progressRefs = [progressRef1, progressRef2, progressRef3];
    const cards = cardsRef.current || [];

    //  console.log("document.body.scrollHeight = ", document.body.scrollHeight, " viewportHeight ", viewportHeight);

    const scrollRange = document.body.scrollHeight - viewportHeight;
    // console.log("document.body.scrollHeight = ", document.body.scrollHeight, " viewportHeight = ", viewportHeight, " scrollRange = ", scrollRange);

    // Normalize start & step based on scrollable height

    const delay = device_type == "mobile" ? 0.8 : 0.30;
    const baseScrollStart = scrollRange * (device_type == "mobile" ? 0.26 : 0.21);

    //scrollRange * stepRatio;

    cards.forEach((card, index) => {
      const cardHeight = card?.offsetHeight || 0; // dynamically use each card's height
      const showTrigger = baseScrollStart + ((cardHeight * index) * delay);
      const hideTrigger = showTrigger - cardHeight;

      // console.log(index, " baseScrollStart = ", baseScrollStart, " cardHeight:", cardHeight, " localScrollY: ", localScrollY, "showTrigger:", showTrigger, "hideTrigger:", hideTrigger);

      if (localScrollY > 0 && localScrollY >= showTrigger) {
        // console.log(index, "== SHOW ==", showTrigger);
        let local = 1;
        card.style.opacity = `${local}`;
        card.style.transform = `translateY(${30 * (1 - local)}px)`;
        card.style.pointerEvents = local > 0.95 ? "auto" : "none";
      } else if (localScrollY < showTrigger) {
        card?.classList.remove("visible");
        let local = 0;
        card.style.opacity = `${local}`;
        card.style.transform = `translateY(${30 * (1 - local)}px)`;
        card.style.pointerEvents = local > 0.95 ? "auto" : "none";
      }

      const progress = Math.min(
        Math.max(((localScrollY - hideTrigger) / cardHeight) * 100, 0),
        100
      );

      if (progressRefs[index]?.current) {
        progressRefs[index].current.style[direction] = `${progress}%`;
      }
    });
  };

  const ipadVisibility = () => {
    // const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    // const zoomRatio = window.devicePixelRatio || 1;
    //const isMobile = viewportWidth < 800;
    const direction = "height";

    const sectionTop = descRef.current?.offsetTop || 0;
    const localScrollY = scrollY;

    const progressRefs = [progressRef1, progressRef2, progressRef3];
    const cards = cardsRef.current || [];

    //  console.log("document.body.scrollHeight = ", document.body.scrollHeight, " viewportHeight ", viewportHeight);

    const scrollRange = document.body.scrollHeight - viewportHeight;
    //  console.log("document.body.scrollHeight = ", document.body.scrollHeight, " viewportHeight = ", viewportHeight, " scrollRange = ", scrollRange);

    // Normalize start & step based on scrollable height

    const delay = 0.90;
    const baseScrollStart = scrollRange * 0.21;

    //scrollRange * stepRatio;

    cards.forEach((card, index) => {
      const cardHeight = card?.offsetHeight || 0; // dynamically use each card's height
      const showTrigger = baseScrollStart + ((cardHeight * index) * delay);
      const hideTrigger = showTrigger - cardHeight;

      // console.log(index, " baseScrollStart = ", baseScrollStart, " cardHeight:", cardHeight, " localScrollY: ", localScrollY, "showTrigger:", showTrigger, "hideTrigger:", hideTrigger);

      if (localScrollY > 0 && localScrollY >= showTrigger) {
        // console.log(index, "== SHOW ==", showTrigger);
        let local = 1;
        card.style.opacity = `${local}`;
        card.style.transform = `translateY(${30 * (1 - local)}px)`;
        card.style.pointerEvents = local > 0.95 ? "auto" : "none";
      } else if (localScrollY < showTrigger) {
        card?.classList.remove("visible");
        let local = 0;
        card.style.opacity = `${local}`;
        card.style.transform = `translateY(${30 * (1 - local)}px)`;
        card.style.pointerEvents = local > 0.95 ? "auto" : "none";
      }

      const progress = Math.min(
        Math.max(((localScrollY - hideTrigger) / cardHeight) * 100, 0),
        100
      );

      if (progressRefs[index]?.current) {
        progressRefs[index].current.style[direction] = `${progress}%`;
      }
    });

  }

  const setSectionHeight_old = () => {
    const cardsCount = 3;
    const viewportHeight = window.innerHeight;

    // Clamp viewport height for consistent behavior
    const effectiveHeight = Math.min(Math.max(viewportHeight, 600), 1000);

    // Give one full viewport per card + one extra for smooth exit
    const totalScrollHeight = effectiveHeight * (cardsCount + 1);

    if (sectionRef.current) {
      sectionRef.current.style.height = `${totalScrollHeight}px`;
    }

    if (wrapperRef.current) {
      wrapperRef.current.style.height = `${effectiveHeight}px`;
      wrapperRef.current.style.position = "sticky";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.overflow = "hidden";
    }

    handleScroll();
  };

  const setSectionHeight = () => {
    if (!wrapperRef.current) return;
    const cards = wrapperRef.current?.querySelectorAll(".card1") || [];

    const heights = Array.from(cards).map((card) => card.offsetHeight || 0);
    const tallest = Math.max(...heights, 0);

    //document.querySelectorAll(".card"); // or refs if you have them
    const cardsCount = 3;
    console.log(cards, " cardsCount ", cardsCount, tallest);

    // Get tallest card height
    const maxCardHeight = Math.max(
      ...Array.from(cards).map(card => card.offsetHeight || 0),
      600 // fallback minimum
    );
    console.log("maxCardHeight = ", maxCardHeight);

    // Clamp to avoid oversizing on huge screens
    const effectiveHeight = Math.min(Math.max(maxCardHeight, 600), 1000);

    // Give one full "card" worth of scroll space per card + one extra for exit
    const totalScrollHeight = effectiveHeight * (cardsCount + 1);

    if (sectionRef.current) {
      sectionRef.current.style.height = `${totalScrollHeight}px`;
    }

    if (wrapperRef.current) {
      wrapperRef.current.style.height = `${effectiveHeight + (totalScrollHeight * 0.06)}px`;
      wrapperRef.current.style.position = "sticky";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.overflow = "hidden";
    }

    handleScroll();
  };

  // compute progress (0..1) while the user scrolls through the "pinned" area
  const computeProgress = () => {
    const section = sectionRef.current;
    const cardsCount = 3;
    const viewportHeight = window.innerHeight;
    if (!section) return 0;

    const sectionTop = section.offsetTop;

    // Start scroll a bit earlier for smoother entry
    const scrolled = window.scrollY - (sectionTop - viewportHeight / 1.3);

    // ↓ shorten scroll area so last card appears earlier
    const pinnedScrollLength = viewportHeight * (cardsCount - 1);
    const raw = scrolled / pinnedScrollLength;

    return Math.min(Math.max(raw, 0), 1);
  };

  let ticking = false;
const handleScroll = () => {
  if (ticking) return;
  ticking = true;

  requestAnimationFrame(() => {
    ticking = false;

    const cardsCount = 3;
    const progress = computeProgress();

    // Keep a slightly faster pacing, but not double-compressed
    const step = 1 / cardsCount; // base fraction per card

    // Slight global acceleration (optional tweak)
    const speedFactor = 0.85; // smaller = faster, 1 = normal

    cardsRef.current.forEach((card, i) => {
      if (!card) return;

      // Define when each card starts/ends
      const start = step * i * speedFactor;
      const end = start + step * speedFactor; // full step, just compressed

      let local = 0;
      if (progress >= end) local = 1;
      else if (progress <= start) local = 0;
      else local = (progress - start) / (end - start);

      // Smooth easing curve for natural feel
      const eased = local >= 0.99 ? 1 : Math.pow(local, 0.8);

      // Apply styles
      card.style.opacity = eased.toFixed(3);
      card.style.transform = `translateY(${20 * (1 - eased)}px)`;
      card.style.pointerEvents = eased > 0.95 ? "auto" : "none";
    });

    // Update progress bars
    [progressRef1, progressRef2, progressRef3].forEach((ref, i) => {
      if (!ref.current) return;
      const p = Math.min(Math.max((progress - i * step) / step, 0), 1);
      ref.current.style.width = `${p * 100}%`;
    });
  });
};


  return (
    <section ref={sectionRef} className="ps how_work position-relative py-5">
      <div ref={wrapperRef} className="container" style={{ marginTop: "10px" }}>
        <h2 className="mb-4"> <img src="/assets/img/about-logo.svg" alt="about-logo" className='me-2 h55 ' />  How it works</h2>

        <div className="scroll-reveal-main row" ref={descRef}>
          <div className="col-lg-4 card1">
            <div className="how_work_box">
              <div
                className="card-scroll"
                key={0}
                ref={(el) => (cardsRef.current[0] = el)}
                data-index={0}
                style={{ padding: "0px", opacity: 0, transform: "translateY(30px)" }}
              >
                <div className="image">
                  <img
                    src={"/assets/img/decode.png"}
                    alt={""}
                    className="rounded"
                    style={{ width: "100%", objectFit: "cover" }}
                  />
                </div>

                <div className="progress-wrap-scroll">
                  <div className="progress-scroll">
                    <div className="step-number">1</div>
                    <div className="fill" ref={progressRef1} style={{ width: "0%" }}></div>
                  </div>
                </div>

                <div className="how_work_box2">
                  <h5 className="fw-bold">Decode</h5>
                  <div className="description">
                    <p className="op0_5">
                      Genetic testing, metabolic profiling, and real-time biomarkers to give you deep
                      insights into your body. We combine genetic testing, metabolic profiling, and
                      real-time biomarkers to give you deep insights into your body.
                    </p>
                    <p>
                      Covers 250+ health markers across diabetes, obesity, heart health, stress,
                      recovery, sleep, cognition, and more.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 card1">
            <div className="how_work_box">
              <div
                className="card-scroll"
                key={1}
                ref={(el) => (cardsRef.current[1] = el)}
                data-index={1}
                style={{ padding: "0px", opacity: 0, transform: "translateY(30px)", height: "100%" }}
              >
                <div className="image">
                  <img
                    src={"/assets/img/reveal.png"}
                    alt={""}
                    className="rounded"
                    style={{ width: "100%", objectFit: "cover" }}
                  />
                </div>

                <div className="progress-wrap-scroll">
                  <div className="progress-scroll">
                    <div className="step-number">2</div>
                    <div className="fill" ref={progressRef2} style={{ width: "0%" }}></div>
                  </div>
                </div>

                <div className="how_work_box2">
                  <h5 className="fw-bold">Reveal</h5>
                  <div className="description">
                    <p className="op0_5">
                      Your age doesn’t tell the full story. EPLIMO shows how your genes + lifestyle
                      are shaping your long-term health trajectory.
                    </p>
                    <p>
                      Example: You may have strong cardiovascular resilience but elevated inflammation
                      levels. With the right interventions, your future health can dramatically
                      improve.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 card1">
            <div className="how_work_box" >
              <div
                className="card-scroll"
                key={2}
                ref={(el) => (cardsRef.current[2] = el)}
                data-index={2}
                style={{ padding: "0px", opacity: 0, transform: "translateY(30px)", height: "100%" }}
              >
                <div className="image">
                  <img
                    src={"/assets/img/personalize.png"}
                    alt={""}
                    className="rounded"
                    style={{ width: "100%", objectFit: "cover" }}
                  />
                </div>
                <div className="progress-wrap-scroll">
                  <div className="progress-scroll">
                    <div className="step-number">3</div>
                    <div className="fill" ref={progressRef3} style={{ width: "0%" }}></div>
                  </div>
                </div>

                <div className="how_work_box2">
                  <h5 className="fw-bold">Personalize</h5>
                  <div className="description">
                    <p className="op0_5">
                      Once your risks and strengths are mapped, EPLIMO builds a clear,
                      step-by-step lifestyle plan that you can actually follow.
                    </p>
                    <ul>
                      <li>DNA-driven diet protocols</li>
                      <li>Personalized fitness strategies</li>
                      <li>Targeted supplements</li>
                      <li>Sleep optimization</li>
                      <li>Stress resilience techniques</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
